module.exports = __webpack_public_path__ + "static/mali_image_1-596b05522ef8fb66d70377f61f723eac.jpg";